import { useEffect, useState } from "react";
import { X } from "react-feather";
import styles from "../tour.module.css";
import { Button, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import { LocalizationProvider, StaticDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddTourTileSlot from "../../prospect/Components/AddTourTileSlot";
import dayjs from "dayjs";
import { useAuth0 } from "@auth0/auth0-react";
import axios from "axios";
import { toast } from "react-smart-toaster";
import Loader from "../../../components/Loader";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const schema = yup.object().shape({
  property_id: yup.string().required("This field is Required"),
  title: yup.string().required("This field is Required"),
});

const EventForm = (props) => {
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [selectedTourTime, setSelectedTourTime] = useState("");
  const [selectedTourDate, setSelectedTourDate] = useState(dayjs());
  const [tourTimeSlotError, setTourTimeSlotError] = useState("");
  const [selectProperty, setSelectProperty] = useState("");
  const [editId, setEditId] = useState(0);

  const { handleSubmit, control, errors, setValue } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: {
      property_id: "",
      title: ""
    },
  });

  useEffect(() => {
    if (props.selectedEvent) {
      let date_time = props.selectedEvent?.extendedProps?.date_time;
      let dateArr = date_time.split(" ");
      setSelectedTourDate(dayjs(dateArr[0]));
      setSelectedTourTime(dateArr[1]);
      setValue('property_id', props.selectedEvent?.extendedProps?.property_id);
      setValue('title', props.selectedEvent?.title);
      setEditId(props.selectedEvent?.extendedProps?.event_id);
    }
  }, [props.selectedEvent]);

  useEffect(() => {
    if (props.selectedProperty > 0) {
      setSelectProperty(props.selectedProperty);
    }
  }, [props.selectedProperty]);

  useEffect(() => {
    if (selectedTourTime !== "") {
      setTourTimeSlotError("");
    }
  }, [selectedTourTime]);

  const onSubmit = async (data) => {
    if (selectedTourTime === "") {
      setTourTimeSlotError("Please select time slot.");
      return false;
    }

    let postData = { ...data, date_time: dayjs(selectedTourDate).format("YYYY-MM-DD") + " " + selectedTourTime };

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    setLoading(true);
    axios.post(process.env.REACT_APP_USER_API_URL + "v1/events", postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      props.setOpenEventFormOpen(false);
      setLoading(false);
      props.setSnackbarMsg(response.data.message);
      props.setSnackbarOpen(true);

      props.onSubmit(response.data.data);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  const onUpdate = async (data) => {
    let postData = { ...data, date_time: dayjs(selectedTourDate).format("YYYY-MM-DD") + " " + selectedTourTime };

    const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

    setLoading(true);
    axios.post(process.env.REACT_APP_USER_API_URL + "v1/events/" + editId, postData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    }).then((response) => {
      props.setOpenEventFormOpen(false);
      setLoading(false);
      props.setSnackbarMsg(response.data.message);
      props.setSnackbarOpen(true);

      props.onUpdate(response.data.data);
    }).catch((error) => {
      if (typeof error.response !== "undefined")
        toast.error(error.response.data.message);
      setLoading(false);
    });
  };

  return (<>
    {loading && <Loader />}
    <DialogTitle id="alert-dialog-title">
      {props?.selectedEvent ? "Edit" : "Add"} Event
      <button onClick={(e) => props.setOpenEventFormOpen(false)}>
        <X />
      </button>
    </DialogTitle>

    <form onSubmit={handleSubmit(props.selectedEvent ? onUpdate : onSubmit)} style={{ display: "contents" }}>
      <DialogContent>
        <DialogContentText>
          <div className={`${styles.Width100}`}>
            <div className={`${styles.PopupFilterRow}`}>
              <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter AddTour`}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Property Name*</InputLabel>
                  <Controller
                    name="property_id"
                    control={control}
                    render={(field) => (<Select
                      {...field}
                      MenuProps={MenuProps}
                      label="Property*"
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                    >
                      {props?.allProperties?.map((item) => {
                        return (<MenuItem key={item?.value} value={item?.value}>
                          {item?.label}
                        </MenuItem>);
                      })}
                    </Select>)}
                  />
                </FormControl>
                {errors.property_id && (<p className={`${styles.AddTourErrorMessage}`}>{errors.property_id.message}</p>)}
              </div>
              <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter AddTour`}>
                <FormControl fullWidth>
                  <Controller
                    name="title"
                    control={control}
                    render={(field) => (<TextField
                      {...field}
                      id="outlined-basic"
                      label="Event Title*"
                    />)}
                  />
                </FormControl>
                {errors.title && (<p className={`${styles.AddTourErrorMessage}`}>{errors.title.message}</p>)}
              </div>
            </div>

            <p className={`${styles.AddTourPopTT}`}>Select Open House Date and Time</p>
            <div className={`${styles.ModalFormGroup} ModalFormGroup`}>
              <div className={`${styles.AddTourModal} AddTourModal`}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <StaticDatePicker
                    orientation="landscape"
                    value={selectedTourDate}
                    onChange={(e) => setSelectedTourDate(e)}
                    disablePast
                  />
                </LocalizationProvider>
              </div>
              <div className={`${styles.AddTourTimeArea}`}>
                <p className={`${styles.TimeSlotTitle}`}>{dayjs(selectedTourDate).format("dddd, MMMM D")}</p>
                <p className={`${styles.AddTourErrorMessage}`}>{tourTimeSlotError !== "" && tourTimeSlotError}</p>
                <AddTourTileSlot
                  setSelectedTourTime={setSelectedTourTime.bind(this)}
                  selectedTourTime={selectedTourTime}
                  selectedTourDate={selectedTourDate}
                  selectProperty={selectProperty}
                />
              </div>
            </div>
          </div>
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button onClick={(e) => props.setOpenHouseFormOpen(false)} className="CancelPopupBU">Cancel</Button>
        <Button className="SubmitPopupBU" type="submit" >{props?.selectedEvent ? "Update" : "Add"}</Button>
      </DialogActions>
    </form>
  </>);
};

export default EventForm;